module.exports = __webpack_public_path__ + "img/09-min.2ad49848.jpg";